<template>
  <div>
    <CRow>
      <CCol col="12">

        <CCard>
          <CCardHeader class="p-1">
            <CRow>
              <CCol col="4" style="text-align: start ;padding:10px 20px 0 20px ">
                <strong v-if="status_form==0">{{ $t('addCity') }}</strong>
                <strong v-else>{{ $t('editCity') }}</strong>
              </CCol>
              <CCol col="4" style="text-align: center ;">

                <strong v-if="status_form!=0">{{edit_name}}</strong>

              </CCol>
              <CCol col="4" style="text-align: end">

                <CButton v-if="status_form==0"  class="mr-1 ml-1" @click="insert_data()" type="submit" size="sm" color="secondary">
                  {{ $t('buttons.submit') }}
                </CButton>
                <CButton v-if="status_form !=0" @click="insert_data()"
                         type="submit" size="sm" color="secondary">
                  {{ $t('buttons.edit') }}
                </CButton>
                <CButton v-if="status_form!=0"
                        @click="emptyList()"
                    class="mr-1"
                    size="sm"
                    color="secondary"
                >{{ $t("buttons.cancel") }}
                </CButton>

              </CCol>
            </CRow>
          </CCardHeader>

          <CCardBody>

            <CRow>
              <CCol col="4">
                <CSelect
                        :label="$t('country')"
                        :value.sync="selected_country"
                        :horizontal="{label: 'col-sm-4', input: 'col-sm-8'}"

                        :options="country_items"
                />
              </CCol>
              <CCol col="4">
                <CSelect
                        :label="$t('components.province')"
                        :value.sync="selected_province"
                        :horizontal="{label: 'col-sm-4', input: 'col-sm-8'}"

                        :options="province_items"
                />
              </CCol>
              <CCol col="4">
                <CInput
                    :label="$t('cityName')"
                    :horizontal="{label: 'col-sm-4', input: 'col-sm-8'}"

                    v-model="name"
                    autocomplete="name"
                />
              </CCol>

            </CRow>

          </CCardBody>
        </CCard>

      </CCol>

    </CRow>

    <CRow>
      <CCol col="6">
        <CCard>

      <CCardBody class="mb-5">
<!--        <CRow>-->
<!--          <CCol col="6">-->
<!--            <CSelect-->
<!--                    :label="$t('country')"-->
<!--                    :value.sync="selected_country2"-->
<!--                    :horizontal="{label: 'col-sm-4', input: 'col-sm-8'}"-->

<!--                    :options="country_items"-->
<!--            />-->
<!--          </CCol>-->
<!--          <CCol col="6">-->
<!--            <CSelect-->
<!--                    :label="$t('components.province')"-->
<!--                    :value.sync="selected_province2"-->
<!--                    :horizontal="{label: 'col-sm-4', input: 'col-sm-8'}"-->

<!--                    :options="province_items2"-->
<!--            />-->
<!--          </CCol>-->
<!--        </CRow>-->
            <CDataTable
                :items="items"
                :fields="fields"
                border
                @row-clicked="table_row_clicked"

                column-filter
                striped
                :items-per-page="10"
                hover
                sorter
                pagination
            >
              <template #row="{item}">

                <td style="text-align: center">
                  <p >{{ item.row_id + 1 }}</p>

                </td>

              </template>
              <template #name="{item}">

                <td>
                  <p >{{ item.title }}</p>

                </td>

              </template>


              <template #operation="{item}">
                <td>
                  <CButton class="mr-1"
                           square
                           size="sm"
                           :title="$t('buttons.edit')"
                           @click="edit_item(item)"
                  >
                    <CIcon class="text-primary" name="cil-pencil"/>
                  </CButton>
                </td>
              </template>


            </CDataTable>
          </CCardBody>

        </CCard>

      </CCol>

    </CRow>

  </div>
</template>

<script>
import axios from "axios";
import {bus} from '../../../main';
import mapboxgl from 'mapbox-gl'
import BTabs from "../../tabs/BTabs";


var items = [];


export default {
  name: 'Login',
  components: {BTabs},
  data() {
    return {
      confirm_delete_name: "confirm" + new Date().getTime() + "_" + this.$vnode.tag,
      map: null,
      edit_name: "",
      fields: [
        {key: 'row', label: this.$t('tables.row'),sorter:false, _style: 'width:5%'},
        {key: 'cityName', label: this.$t('tables.name'), _style: 'width:15%'},
        // {key: 'provinceName', label: this.$t('tables.province'), _style: 'width:10%'},
        // {key: 'cityName', label: this.$t('tables.city'), _style: 'width:15%;'},
        {key: 'operation', label: "", _style: 'width:10%;'},
      ],

      validate_errors: [],
      name: '',
      file: '',
      color: '#ffffff',
      previewImage: '',
      description: '',
      items: items.map((item, row_id) => {
        return {...item, row_id}
      }),

      country_items: [],
      selected_country: 0,
      selected_country2: 0,

      province_items: [],
      province_items2: [],
      selected_province2: 0,
      selected_province: 0,

      city_items: [],
      selected_city: 0,

      table_clicks: 0,
      table_clicks_timer: null,
      details: [],
      collapseDuration: 0,
      status_form: 0
    }
  },
  created() {
  },
  mounted() {
    this.$root.root_validate_errors = [];


    this.get_country();
    bus.$on(this.confirm_delete_name, (data) => {
      // alert(data);
      if (data == "true") {
        this.delete_item();

      } else {
        this.status_form = 0;
      }
    });
    // this.createMap();

  }, watch: {
    '$route.params.cat_id': function () {
      this.get_lists();
    },
    'selected_country': function () {
      this.get_provinces();
    },
    'selected_country2': function () {
      this.get_provinces2();
    },
    'selected_province': function () {
      this.get_lists();
    }
  },
  methods: {
    get_country() {
      var self = this;

      const formData = new FormData();


      // formData.append('id', this.selected_province);


      axios.post('GetCountries', formData, {}).then(function (response) {

        var content_data = response.data;

        // items = content_cats.orders;
        if (content_data.statusCode == 0) {

          self.country_items = [];
          self.country_items = self.sort_array(
                  self.country_items, content_data.data,
                  'id','title');

          self.selected_country = self.country_items[0].value;
          self.selected_country2 = self.country_items[0].value;
          if(self.$i18n.locale=='fa'){
            self.selected_country = self.country_items.filter(x=> x.label=='ایران')[0].value
            self.selected_country2 = self.country_items.filter(x=> x.label=='ایران')[0].value
          }
          if(self.$i18n.locale=='en'){
            self.selected_country = self.country_items.filter(x=> x.label=='England')[0].value
            self.selected_country2 = self.country_items.filter(x=> x.label=='England')[0].value
          }
        } else {
          self.$root.modal_component.show_danger_modal(self.$t('dialogs.error'), content_data.message);

        }


      }).catch(function (error) {

        console.log(error);
      });

    },
    get_provinces() {
      var self = this;

      const formData = new FormData();


      formData.append('id', this.selected_country);



      axios.post('GetStateList', formData, {}).then(function (response) {

        var content_data = response.data;

        // items = content_cats.orders;
        if (content_data.statusCode == 0) {
          self.province_items = [];
          self.province_items = self.sort_array(
                  self.province_items, content_data.data,
                  'id','provinceName');

          self.selected_province2 = self.province_items[0].value;
          self.selected_province = self.province_items[0].value;
        } else {
          self.$root.modal_component.show_danger_modal(self.$t("dialogs.error"), content_data.message);
        }

      }).catch(function (error) {
        console.log(error);
      });

    },
    get_provinces2() {
      var self = this;

      const formData = new FormData();


      formData.append('id', this.selected_country2);



      axios.post('GetStateList', formData, {}).then(function (response) {

        var content_data = response.data;

        // items = content_cats.orders;
        if (content_data.statusCode == 0) {
          self.province_items2 = [];
          self.province_items2 = self.sort_array(
                  self.province_items2, content_data.data,
                  'id','provinceName');

          self.selected_province2 = self.province_items[0].value;
        } else {
          self.$root.modal_component.show_danger_modal(self.$t("dialogs.error"), content_data.message);
        }

      }).catch(function (error) {
        console.log(error);
      });

    },

    table_row_clicked(item, index) {
      this.table_clicks++;
      if (this.table_clicks == 1) {
        this.table_clicks_timer = setTimeout(() => {
          // this.result.push(event.type);
          this.table_clicks = 0
        }, 500);
      } else if (this.table_clicks > 1) {
        clearTimeout(this.table_clicks_timer);
        this.edit_item(item)
        this.table_clicks = 0

      }
    },
    validateForm: function () {
      this.$root.root_validate_errors = [];

      if (this.name != '' ) {
        return true;
      }


      if (this.name == '') {
        this.$root.root_validate_errors.push(this.$t('insertAreaName'));
      }

      return false;
      // e.preventDefault();
    },

    edit_item(item) {
      // this.$set(this.items[item.id], '_toggled', !item._toggled)
      this.name = item.cityName;
      this.selected_country = item.countryId;
      this.edit_name = item.cityName;
      this.status_form = item.cityId;
      // this.$nextTick(() => {
      //     this.collapseDuration = 0
      // })
    },
    emptyList() {
      // this.$set(this.items[item.id], '_toggled', !item._toggled)
      this.name = '';
      this.color = '';
      this.description = '';
      this.previewImage = '';
      this.status_form = 0;

      // this.$nextTick(() => {
      //     this.collapseDuration = 0
      // })
    },
    get_lists() {
      var self = this;

      const formData = new FormData();


      formData.append('id', this.selected_province);


      axios.post('GetCityListByStateId', formData, {}).then(function (response) {

        var content_data = response.data;

        // items = content_cats.orders;
        if (content_data.statusCode == 0) {
          self.items = content_data.data.map((item, row_id) => {
            return {...item, row_id}
          });
        } else {
          self.$root.modal_component.show_danger_modal(self.$t("dialogs.error"), content_data.message);
        }

      }).catch(function (error) {
            console.log(error);
          });

    },
    goSubCategories(item) {
      this.$router.push({path: '/users/list-users/' + item.id});
    },

   insert_data() {
      if (!this.validateForm()) {
        console.log("validate form is false" + this.validate_errors);
        return true;
      }
      let self = this;
      const formData = new FormData();
      let url;
      if (this.status_form == 0) {
        url = "AddCityRec";
      } else {
        url = "EditCityRec";
        formData.append('id', this.status_form)

      }

      formData.append('CityName', this.name);
      formData.append('ProvinceId', this.selected_province);

      axios.post(url, formData, {}).then((res) => {

        self.status_form = 0;
        self.name = '';
        self.color = '';
        self.description = '';
        self.previewImage = '';
        self.get_lists();
        self.$root.modal_component.show_api_response_modals(res);

      }).catch(function (error) {
            console.log(error);
          });

    },
    delete_item_dialog(item) {
      this.$root.modal_component.show_confirm_modal(this.$t("dialogs.warning"), this.$t("dialogs.deleteMessage"), [this.$t("dialogs.ok")], this.confirm_delete_name);

      this.status_form = this.items[item.row_id].id;

    },
    delete_item() {


      let self = this;
      const formData = new FormData()
      let url;
      url = "DeleteCityRec";


      formData.append('id', this.status_form);

      axios.post(url, formData, {}).then((res) => {
        //
        self.$root.modal_component.show_api_response_modals(res);

        self.status_form = 0;

        self.get_lists();


      })
          .catch(function (error) {

            console.log(error);
          });
// this.get_categories();
      // this.$router.push({ path: '/posts/'});
    },
  }
}

</script>
